import { React } from 'Imports';
import SliderDialog from '$Components/Shared/MaterialUIComponents/SliderDialog';
import { ConfigService } from '$State/ConfigFreezerService';
import SingleSelect from '$Components/FilterComponents/Filters/SingleSelect';
import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { IDropdownItem } from '$Components/FilterComponents/VPDropdown';
import { AutoScoreSettingsResponse } from '$Generated/api';

const styles = require('./AutoScoreDrawer.scss') as {
    pickerContent: string;
    select: string;
    headerText: string;
    editAutoScoreWarnText: string;
    scoreContainer: string;
    scoreLabel: string;
    scoreDropdown: string;
};

interface IAutoScoreDrawerProps {
    open: boolean;
    onClose: () => void;
    isEdit: boolean;
    handleAssignEventAutoScore: (eventTypeId: number, scoreId: number) => void;
    eventTypesItems?: IDropdownItem[];
    scoresItems?: IDropdownItem[];
    selectedAutoScoreSetting?: AutoScoreSettingsResponse | null;
}

type AutoScoreDrawerProps = IAutoScoreDrawerProps;

export const AutoScoreDrawer = (props: AutoScoreDrawerProps) => {
    const [eventTypeSelected, setEventTypeSelected] = useState<number | null>(null);
    const [scoreSelected, setScoreSelected] = useState<number | null>(null);
    const title = props.isEdit ? 'Edit Event Auto-Score' : 'Assign Event Auto-Score';
    const submitActionText = props.isEdit ? 'Save' : 'Assign';
    const isRunningStandAlone = ConfigService?.isRunningStandAlone();
    const isMovileView = isRunningStandAlone ? window.innerWidth < 1858 : window.innerWidth < 1553;

    const handleOnClose = () => {
        props.onClose();
    };

    const handleEventTypeChange = (selectedItem: IDropdownItem | null) => {
        setEventTypeSelected(selectedItem?.value);
    };

    const handleScoreChange = (selectedItem: IDropdownItem | null) => {
        setScoreSelected(selectedItem?.value);
    };

    const handleOnSubmit = () => {
        props.handleAssignEventAutoScore(eventTypeSelected ?? 0, scoreSelected ?? 0);
    };

    useEffect(() => {
        if (props.selectedAutoScoreSetting && props.isEdit) {
            setEventTypeSelected(props.selectedAutoScoreSetting?.videoEventTypeId ?? 0);
            setScoreSelected(props.selectedAutoScoreSetting?.videoEventScoreId ?? 0);
        } else {
            setEventTypeSelected(null);
            setScoreSelected(null);
        }
    }, [props.selectedAutoScoreSetting, props.eventTypesItems]);

    return (
        <SliderDialog
            open={props.open}
            title={title}
            onClose={handleOnClose}
            onSubmit={handleOnSubmit}
            submitButtonText={submitActionText}
            isEncompass
            isRunningStandAlone={isRunningStandAlone}
            widthFitContent
            submitButtonDisabled={
                !eventTypeSelected ||
                !scoreSelected ||
                (props.isEdit &&
                    eventTypeSelected === props.selectedAutoScoreSetting?.videoEventTypeId &&
                    scoreSelected === props.selectedAutoScoreSetting?.videoEventScoreId)
            }
        >
            <Box sx={{ padding: '24px' }}>
                <SingleSelect
                    key={'displayName'}
                    label={'Event Type'}
                    items={props.eventTypesItems || []}
                    disabled={false}
                    selectionChanged={(selectedItem: IDropdownItem | null) => handleEventTypeChange(selectedItem)}
                    searchable
                    selectedValue={eventTypeSelected}
                    isMobileView={isMovileView}
                    sortItemsByValue={false}
                    required
                />
                <Box className={styles.scoreContainer}>
                    <span className={styles.scoreLabel}>Always score as</span>
                    <div className={styles.scoreDropdown}>
                        <SingleSelect
                            key={'displayName'}
                            label={'Score'}
                            hideLabel
                            items={props.scoresItems || []}
                            disabled={false}
                            selectionChanged={(selectedItem: IDropdownItem | null) => handleScoreChange(selectedItem)}
                            searchable={false}
                            selectedValue={scoreSelected}
                            isMobileView={isMovileView}
                            sortItemsByValue={false}
                        />
                    </div>
                </Box>
            </Box>
        </SliderDialog>
    );
};
